export const noError = {
  isError: 'false',
}

export const initialState = {
  error: noError,
  isLoading: false,
  cart: JSON.parse(localStorage.getItem('cart')) || [],
  activeCartId:''
}